<template>
  <router-link
    :to="to"
    class="group flex items-center px-2 py-2 h-10 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-100 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150"
  >
    <div class='ml-6'>
      {{ title }}
    </div>
  </router-link>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    nav: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>
